import { musicPlatform } from 'fitbeat.gym-core/config';
import React, { FunctionComponent } from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import { connect } from 'react-redux';
import AppleMusicIcon from '../../../assets/images/appleMusic.svg';
import SpotifyIcon from '../../../assets/images/spotify.svg';
import Theme from '../../../theme';
import { defaultScale, scaleText } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { orientationSelector } from '../../selectors';
import { musicSourceSelected, spotifyTilePressed, switchSpotifyAccount } from './actions';
import { musicSourceIcons } from './SelectMusicSourceScreen';
import { getErrorSelector, spotifyDisplayNameSelector } from './selectors';
import build from '../../../config/build';
interface IProps {
  musicSourceSelected: (source: string) => void;
  switchSpotifyAccount: () => void;

  showSelectGeneric: boolean;
  orientation: string;
  allowOnlyGeneric: boolean;
  spotifyDisplayName: string;
  t: (key: string, options?: any) => string;
}

const SelectMusicSourceButtonsComponent: FunctionComponent<IProps> = ({ showSelectGeneric = true, isAlphaFeatureUser = false, spotifyDisplayName, t,error, switchSpotifyAccount, ...props }) => {
  const portrait = () => props.orientation === 'PORTRAIT';
  const disableAppleMusic = (Platform.OS === 'android' && !isAlphaFeatureUser) || props.allowOnlyGeneric;
  const spotifyTileText = !!spotifyDisplayName && error ? t('reconnectSpotify'): t('spotify')
  const showSwitchAccount = !!spotifyDisplayName && build.variant.isElite;
  const iconWidth = defaultScale(44)
  const iconHeight = defaultScale(44)

  return (
    <>
      <View style={[styles.platformTileContainer, (!portrait() && showSelectGeneric) && { flexWrap: 'wrap' }]}>
        <View>
          <TouchableOpacity disabled={props.allowOnlyGeneric}
                            style={[styles.platformTile, styles.spotify, props.allowOnlyGeneric && styles.disabled]}
                            onPress={() => props.spotifyTilePressed()}>
            <SpotifyIcon width={iconWidth} height={iconHeight} style={styles.iconStyle}/>
            <Text style={styles.tileText}>{spotifyTileText}</Text>
            {!!spotifyDisplayName && <Text style={[styles.tileText, {marginTop: defaultScale(0)}]}>({spotifyDisplayName})</Text>}
          </TouchableOpacity>
          { showSwitchAccount && ( <TouchableOpacity onPress={switchSpotifyAccount}>
              <Text style={styles.switchAccountText}>{t('switchSpotifyAccount')}</Text> 
            </TouchableOpacity> )}
        </View>
        <TouchableOpacity disabled={disableAppleMusic}
                          style={[styles.platformTile, styles.appleMusic, disableAppleMusic && styles.disabled]}
                          onPress={() => props.musicSourceSelected(musicPlatform.AppleMusic)}>
          <AppleMusicIcon width={iconWidth} height={iconHeight} style={styles.iconStyle}/>
          <Text style={styles.tileText}>{t('appleMusic')}</Text>
        </TouchableOpacity>
        {
          !portrait() && showSelectGeneric &&
          <TouchableOpacity style={[styles.platformTile, styles.genericMusic]}
                            onPress={() => props.musicSourceSelected(musicPlatform.FitbeatMusic)}>
            <FastImage
              style={{ width: iconWidth, height: iconHeight, ...styles.iconStyle }}
              source={musicSourceIcons.generic}
              resizeMode={FastImage.resizeMode.contain}
              tintColor={Theme.WHITE}
            />
            <Text style={styles.tileText}>{t('generic')}</Text>
            <Text style={[styles.tileText, { marginTop: 0 }]}>({t('limitedPlaylist')})</Text>
          </TouchableOpacity>
        }
      </View>
      {
        portrait() && showSelectGeneric &&
        <TouchableOpacity style={[styles.platformTile, styles.platformTileWide, styles.genericMusic]}
                          onPress={() => props.musicSourceSelected(musicPlatform.FitbeatMusic)}>
          <FastImage
            style={{ width: defaultScale(55), height: defaultScale(55) }}
            source={musicSourceIcons.generic}
            resizeMode={FastImage.resizeMode.contain}
            tintColor={Theme.WHITE}
          />
          <Text style={styles.tileTextWide}>{t('generic')} ({t('limitedPlaylist')})</Text>
        </TouchableOpacity>
      }
    </>
  );
};

const mapStateToProps = (state: IAppStore) => {
  return {
    orientation: orientationSelector(state),
    allowOnlyGeneric: state.homeWorkouts.onlyGenericMusicAllowed,
    spotifyDisplayName: spotifyDisplayNameSelector(state),
    error: getErrorSelector(state)
  };
};

export const SelectMusicSourceButtons =
    connect(mapStateToProps, { musicSourceSelected, switchSpotifyAccount, spotifyTilePressed })(SelectMusicSourceButtonsComponent);

const styles = StyleSheet.create({
  platformTileContainer: {
    flexDirection: 'row',
  },
  platformTile: {
    width: defaultScale(150),
    height: defaultScale(150),
    alignItems: 'center',
    borderRadius: defaultScale(5),
    marginHorizontal: defaultScale(10),
  },
  platformTileWide: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: defaultScale(20),
    width: defaultScale(150 * 2 + 20),
    height: defaultScale(120),
  },
  spotify: {
    backgroundColor: '#65c26e',
  },
  appleMusic: {
    backgroundColor: '#ff2d69',
  },
  genericMusic: {
    backgroundColor: Theme.BLACK,
    borderWidth: 1,
    borderColor: Theme.GREY,
  },
  tileText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginTop: defaultScale(14),
  },
  tileTextWide: {
    ...Theme.textStyle.bodyCopyReg,
    marginLeft: defaultScale(10),
    color: Theme.WHITE,
  },
  disabled: {
    backgroundColor: Theme.GREY_DARK_MEDIUM,
  },
  switchAccountText: {
    fontFamily: Theme.Custom400,
    fontSize: scaleText(11),
    color: Theme.WHITE,
    marginTop: defaultScale(10),
    alignSelf: 'center',
    textDecorationLine: 'underline'
  },
  iconStyle: {
    marginTop: defaultScale(34)
  },
});
